<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item >首页</el-breadcrumb-item>
      <el-breadcrumb-item >代理商列表</el-breadcrumb-item>
    </el-breadcrumb>




    <el-table
      :data="agent_user_data"
      stripe
      style="width: 100%; margin-top: 10px">

      <el-table-column prop="id" label="ID" > </el-table-column>

      <el-table-column prop="username" label="代理商名" width="180">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :content="scope.row.username"
            placement="top-start"
          >
            <span>{{ scope.row.username }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="代理等级">
        <template slot-scope="scope">
          {{ scope.row.level }}
        </template>
      </el-table-column>
        <el-table-column  label="区域" prop="area_name">
            <template slot-scope="scope">


                <span @click="area_show(scope.row.id)">查看区域</span>

            </template>


        </el-table-column>

      <el-table-column prop="sales.purchase_price" label="采购金额"> </el-table-column>
      <el-table-column prop="sales.sales_price" label="销售金额">
      </el-table-column>


    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>



      <el-dialog
              title="区域"
              :visible.sync="dialog_area_visible"
              width="30%"
              >

          <p v-html="area_show_content">


          </p>
          <span slot="footer" class="dialog-footer">

  </span>
      </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        agent_user_data:[],
        area_province_data:{},
        id:"",
        totalpages:0,

        form:{
            name:"",
            type:'',
        },
        dialog_area_visible: false,
        area_show_content:"",
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      agent: false,
      product_stock: {},
      dialog_msg_visible: false,
      dialog_restore_visible: false,
      page: 1,
    };
  },
  methods: {
    ...mapActions({
      agentUserIndexAction: "agentUserIndexAction",
      lowerLevelAgentUserAction:"lowerLevelAgentUserAction"
    }),

    area_show(id){
        this.area_show_content=this.area_province_data[id]
        this.dialog_area_visible=true

    },

    setUserPassword(id){

        this.$router.push({"name":"agent_password_index","params":{user_id:id}})

    },
    handleUpdate(index, row) {
      this.tableData[index].editeFlag = false;
      this.tableData[index] = row;
      //alert(JSON.stringify(this.tableData[index]));
      //alert(row['id']);
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    discount() {
      const len = this.multipleSelection.length;
      if (len == 0) {
        this.$message.error("请选择分销商");
      } else {
        this.dialog_msg_visible = true;
      }
    },
    dialog_restore() {
      const len = this.multipleSelection.length;
      if (len == 0) {
        this.$message.error("请选择分销商");
      } else {
        this.dialog_restore_visible = true;
      }
    },


   getAgentUser(index, row) {
      this.dialogStoreVisible = true;
      this.product_stock = row;
      console.log(index, row);
    },
    agentStat(row) {
      const id = row.id;
      this.$router.push({
        name: "agent_stat",
        query: {
          id: id,
        },
      });
    },
    agent_edit(row) {
      const id = row.id;
      this.$router.push({
        name: "agent_user_edit",
        params: { id: id },
      });
    },
    agent_orders(user_id, type) {
      this.$router.push({
        name: "order_my_index",
        params: { user_id: user_id, type: type },
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      this.lowerLevelAgentUserAction({ page: page,name:this.form.name,id:this.id });
    },
      search(){

          this.changePageData(1)
      }
  },
  created() {
    this.id=this.$route.params.id

    this.lowerLevelAgentUserAction({ page: this.page,name:this.form.name,id:this.id });
  },
  //tableData
  computed: mapState({
    result: (state) => state.agentuser.result,
  }),
    watch:{
        result(val){

            if(val.code==200){

                this.agent_user_data=val.data
                this.totalpages=val.totalpages
                let area_data={}
                for(let i in this.agent_user_data){
                    let str=""
                    for (let ii in this.agent_user_data[i]['area_name']){
                        str=str+this.agent_user_data[i]['area_name'][ii].join("=>")+"<br/>"



                    }
                    area_data[this.agent_user_data[i]['id']]=str

                }
                this.area_province_data=area_data


            }
        }

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
